import { Modal, ModalClose, ModalDialog, Stack, Typography } from '@healthinal/ui';
import type { ReactNode } from 'react';
import { ChangeHistoryEntry } from './ChangeHistoryEntry.tsx';
import type { ChangeHistoryEntryData } from './historyTypes.ts';

export type ChangeHistoryModalEntry = ChangeHistoryEntryData & {
  id: string;
  actionLabel: string;
  changedBy?: ReactNode;
};

type ChangeHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  subject: ReactNode;
  entityName: ReactNode;
  entries: ChangeHistoryModalEntry[];
  emptyText?: string;
  isLoading?: boolean;
};

export function ChangeHistoryModal({
  open,
  onClose,
  title,
  subject,
  entityName,
  entries,
  emptyText = 'Keine Einträge vorhanden.',
  isLoading = false,
}: ChangeHistoryModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ width: 800 }}>
        <ModalClose />
        <Typography level="h4">{title}</Typography>
        <Stack gap={2} sx={{ maxHeight: '60dvh', overflowY: 'auto', mt: 1 }}>
          {isLoading ? (
            <Typography level="body-md">Lade Daten...</Typography>
          ) : entries.length === 0 ? (
            <Typography level="body-md">{emptyText}</Typography>
          ) : (
            entries.map((entry) => (
              <ChangeHistoryEntry
                key={entry.id}
                entry={entry}
                subject={subject}
                entityName={entityName}
                actionLabel={entry.actionLabel}
                changedBy={entry.changedBy}
              />
            ))
          )}
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
